import { ICloudVen, ICreateCloudVen, IUpdateCloudVen } from '../../../domain/ven/interface';

export type TCloudVENDispatchType = 'program' | 'site' | 'resource_id' | 'group_id';

export interface ICloudVenFormValues {
    id?: string;
    ven_username?: string;
    ven_password?: string;
    ven_id?: string;
    ven_vtn_id?: string;
    ven_uri?: string;
    ven_profile?: string;
    ven_registration_id?: string;
    dispatch_type?: TCloudVENDispatchType | null;
    program_ids?: number[];
    company_id?: number;
    site_id?: number;
    dispatch_by_resource_id?: boolean;
    ven_group_id?: string;
    ven_detailed_logging?: boolean;
    ven_enabled?: boolean;
}

export function mapCloudVenToFormValues(ven: ICloudVen | Partial<ICloudVen>): ICloudVenFormValues {
    const program_ids = ven.programs?.map(p => (p as any).program_id).filter(Boolean) as number[] | undefined;
    const company_id = ven.sites?.[0]?.company_id;
    const site_id = ven.sites?.[0]?.site_id;

    return {
        id: ven.id,
        ven_id: ven.ven_id,
        ven_username: ven.ven_username,
        ven_password: ven.ven_password,
        ven_vtn_id: ven.ven_vtn_id,
        ven_uri: ven.ven_uri,
        ven_profile: ven.ven_profile,
        ven_registration_id: ven.ven_registration_id,
        program_ids: program_ids,
        company_id: company_id,
        site_id: site_id,
        ven_detailed_logging: Boolean(ven.ven_detailed_logging),
        ven_enabled: ven.ven_enabled === undefined ? true : Boolean(ven.ven_enabled),

        dispatch_type: ven.dispatch_type,
    };
}

export function mapFormValuesToCloudVenDto(
    form: ICloudVenFormValues,
    opts?: {
        cert?: string | undefined;
        key?: string | undefined;
    }
): ICreateCloudVen | IUpdateCloudVen {
    let dto = {
        ...form,
        dispatch_type: form.dispatch_type || null,
        site_ids: form.site_id ? [form.site_id] : undefined,
        program_ids: form.program_ids ? form.program_ids : undefined,
        ven_cert: opts?.cert,
        ven_key: opts?.key,
    };

    delete dto.site_id;
    delete dto.company_id;
    delete dto.dispatch_by_resource_id;

    return dto as ICreateCloudVen | IUpdateCloudVen;
}
